// extracted by mini-css-extract-plugin
export default {"modalWindow":"ModalWindow_modalWindow__8SLTG","modalWindow__content":"ModalWindow_modalWindow__content__zwc5E","active":"ModalWindow_active__HxICL"};